import { isContactInvalid, isContactMain } from './ContactService';
import type { Address } from './ContactTypes';
import type { NewStructureContact } from './ContactAdapterTypes';
import { isNewAddress } from './ContactAdapterService';
import { selectContacts } from './useContacts';

export function getAddressesFromContacts(contacts: NewStructureContact[] = []): Address[] {
    const addresses = contacts.filter(isNewAddress);
    return addresses.map(({ id, flags, address }) => ({
        id,
        isMainContact: isContactMain(flags),
        isInvalid: isContactInvalid(flags),
        ...address,
    }));
}

export function getAddresses(): Address[] {
    return getAddressesFromContacts(selectContacts());
}
